import React, { useEffect } from 'react';
import star2 from '../assets/images/star2.svg';
import { useTranslation } from 'react-i18next';

const HeaderTherapist = ({ currentTherapist, closeModal2 }) => {
  const { t } = useTranslation('therapist');
  useEffect(() => {
    window.scrollTo({ top: 152, behavior: 'smooth' });
  }, [currentTherapist]);
  return (
    <>
      <div className="header-therapist profile-book">
        <div className='modal-therapist'>
          <div className="card-therapist">
            <img src={currentTherapist?.media?.length ? currentTherapist.media[0].original_url : ''} alt={currentTherapist?.firstname} className="profile-picture-choose" />
            <h2 className="name-therapist">{currentTherapist?.firstname}</h2>
          </div>
          <div className="text-wrapper-3"> </div>
          <div className="rating"><img className="https-app" src={star2} /> {currentTherapist?.extra?.rating}/5</div>
          <a className="header-close" onClick={() => closeModal2()}>X</a>
        </div>
      </div>

      <h2 className="profile-h2" style={{ textAlign: 'center', fontWeight: 700 }}>{t('therapist:choose_date')}</h2>
    </>
  );
};

export default HeaderTherapist;
